import React from 'react';

import { addThousandSeparator } from '../../helpers/format';

class SDGTableTBody extends React.PureComponent {
  renderColumnList(data) {
    return data.map((item, index) => {
      const className = (item.colspan > 1) ? 'sdg-table__info' : '';
      let ColumnComponent, text, padding = false;

      if (index === 0 && item.colspan === 1) {
        ColumnComponent = 'th';
        text = item.text;
        padding = !item.text.startsWith("6.1.1");
      } else {
        ColumnComponent = 'td';
        text = addThousandSeparator(item.text);
      }

      return (
        <ColumnComponent
          colSpan={ item.colspan }
          key={ index }
          className={ className }
          style={{ "padding-left": padding ? "28px" : "none" }}
        >
          { text }
        </ColumnComponent>
      );
    });
  }

  renderRowList() {
    const data = this.props.data;

    return data.map((item, index) => {
      return (
        <tr key={ index }>
          { this.renderColumnList(item) }
        </tr>
      );
    });
  }

  render() {
    return (
      <tbody>
        { this.renderRowList() }
      </tbody>
    )
  }
}

export default SDGTableTBody;



// WEBPACK FOOTER //
// ./src/components/SustainableDevGoals/SDGTableTBody.js